const SLACK_WEBHOOK_URL = process.env.NEXT_PUBLIC_SLACK_WEBHOOK_URL;
// Environment detection
const isLocalhost = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const isLocalEnv = process.env.NEXT_ENV === 'local';
// Debug flag to enable logging from localhost/local environments
let enableLocalhostLogging = false;
/**
 * Format current date as a readable string
 */
const getFormattedDate = () => {
    const now = new Date();
    return now.toISOString().replace('T', ' ').substr(0, 19);
};
/**
 * Enable or disable logging from localhost/local environments
 * @param enable Whether to enable logging from localhost
 */
const setLocalhostLogging = (enable) => {
    enableLocalhostLogging = enable;
};
/**
 * Send logs to Slack while handling potential CORS issues
 * @param props Log properties
 * @param isError Whether this is an error log
 */
const sendToSlack = async (props, isError = false) => {
    // Skip logging for localhost/local environment unless explicitly enabled
    if ((isLocalhost || isLocalEnv) && !enableLocalhostLogging) {
        console.log(`Slack ${isError ? 'error' : 'info'} logging skipped in local environment:`, props);
        return;
    }
    if (!SLACK_WEBHOOK_URL) {
        console.error('Slack webhook URL is not set');
        return;
    }
    const { log, method, error } = props;
    const formattedDate = getFormattedDate();
    const message = isError
        ? `🚨 Event Error ${method} - ${log} - ${error || 'Unknown error'} - ${formattedDate}`
        : `Event Log ${method} - ${log} - ${formattedDate}`;
    try {
        // Using no-cors mode to prevent CORS errors
        await fetch(SLACK_WEBHOOK_URL, {
            method: 'POST',
            mode: 'no-cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                text: message,
            }),
        });
    }
    catch (fetchError) {
        console.error(`Failed to send ${isError ? 'error' : 'info'} log to Slack:`, fetchError);
    }
};
/**
 * Send informational logs to Slack
 */
const logInfoToSlack = async (props) => {
    await sendToSlack(props, false);
};
/**
 * Send error logs to Slack
 */
const logErrorToSlack = async (props) => {
    await sendToSlack(props, true);
};

export { logErrorToSlack, logInfoToSlack, setLocalhostLogging };
//# sourceMappingURL=logToSlack.js.map
